const defaultAppComponentsData = require("../../tusk/modules/appComponents");

const brasilAppComponents = {
    LanguageSwitcher: () => import('./components/layout/LanguageSwitcher.vue'),
    TheFooter: () => import('./components/layout/TheFooter.vue'),
    Register: () => import('./components/signIn/Register.vue'),
    QuickRegister: () => import('./components/signIn/QuickRegister.vue'),
    SignIn: () => import('./components/signIn/SignIn.vue'),
    RegistrationForm: () => import('./components/signIn/RegistrationForm.vue'),
    LoginForm: () => import('./components/signIn/LoginForm.vue'),

    /* SPORTBOOK */
    Sportsbook: () => import('./components/pages/parts/target/AltenarSportsbook.vue'),
};

const brasilEntryPointComponents = {

};

let appComponents = Object.assign(defaultAppComponentsData.appComponents, brasilAppComponents);

let entryPointComponents = Object.assign(defaultAppComponentsData.entryPointComponents, brasilEntryPointComponents);

module.exports = {
    appComponents,
    entryPointComponents,
};
